import { Link } from 'react-router-dom'

export interface EntityCountChipProps {
  count: number
  /** Drill-down destination when count > 0. */
  to: string
  /** e.g. "legal entity" / "legal entities" — used for the accessible name. */
  entityLabelSingular: string
  entityLabelPlural: string
  zeroLabel?: string
}

/**
 * Reusable count → drill-link cell (design-system.md §4.1 "roll-up figures
 * are drill-through"). Zero renders as muted, non-interactive text — a
 * count of zero is not a broken link, it is information.
 */
export function EntityCountChip({
  count,
  to,
  entityLabelSingular,
  entityLabelPlural,
  zeroLabel,
}: EntityCountChipProps) {
  if (count === 0) {
    return <span style={{ color: 'var(--iw-text-subtle)' }}>{zeroLabel ?? `No ${entityLabelPlural}`}</span>
  }
  const label = count === 1 ? entityLabelSingular : entityLabelPlural
  return (
    <Link
      to={to}
      className="iw-pill iw-pill--neutral"
      style={{ textDecoration: 'none' }}
      aria-label={`${count} ${label} — view list`}
    >
      {count} {label}
    </Link>
  )
}
